webpackJsonp([235524998450190],{

/***/ 182:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(4);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(7);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _BannerLanding = __webpack_require__(9);
	
	var _BannerLanding2 = _interopRequireDefault(_BannerLanding);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//import { Grid, Row, Col } from 'react-flexbox-grid';
	
	var pageTitle = "Suivi securite";
	var pageContent = ["Un doute sur la sécurité de votre site Internet ou applications ? ", "Besoin de mises à jours spécifiques  ? "];
	
	var Generic = function Generic(props) {
		return _react2.default.createElement(
			'div',
			{ style: props.transition && props.transition.style },
			_react2.default.createElement(
				_reactHelmet2.default,
				null,
				_react2.default.createElement(
					'title',
					null,
					'Web 2 Alpes - Suivi s\xE9curit\xE9 de sites internet, applications, poste de travail, serveurs, par-feu et r\xE9seaux informatique'
				),
				_react2.default.createElement('meta', { name: 'description', content: 'Suivi s\xE9curit\xE9 de sites internet, applications, poste de travail, serveurs, par-feu et r\xE9seaux informatique' }),
				_react2.default.createElement('meta', { name: 'language', content: 'fr-FR' }),
				_react2.default.createElement('meta', { 'http-equiv': 'content-type', content: 'text/html; charset=UTF-8' }),
				_react2.default.createElement('meta', { 'http-equiv': 'content-language', content: 'fr-FR' })
			),
			_react2.default.createElement(_BannerLanding2.default, { title: pageTitle, content: pageContent, particles: 'infra' }),
			_react2.default.createElement(
				'div',
				{ id: 'main', className: 'alt' },
				_react2.default.createElement(
					'section',
					{ id: 'support', className: 'tiles' },
					_react2.default.createElement(
						'article',
						{ className: 'full-medium' },
						_react2.default.createElement(
							'div',
							{ className: 'inner' },
							_react2.default.createElement(
								'header',
								{ className: 'major' },
								_react2.default.createElement(
									'h2',
									null,
									'Une necessite !'
								)
							),
							_react2.default.createElement(
								'p',
								null,
								'Aujourd\'hui, la s\xE9curit\xE9 est devenue un enjeu majeur dans le monde de l\'informatique. Face aux incidents majeurs r\xE9p\xE9t\xE9s et relay\xE9s par la presse ces derni\xE8res ann\xE9es, elle est devenue incontournable. La l\xE9gislation \xE9volue d\'ailleurs dans ce sens avec ',
								_react2.default.createElement(
									'strong',
									null,
									'une nouvelle l\xE9gislation (',
									_react2.default.createElement(
										'a',
										{ href: 'https://www.cnil.fr/fr/principes-cles/rgpd-se-preparer-en-6-etapes', target: '_blank' },
										'RGPD'
									),
									')'
								),
								'.'
							),
							_react2.default.createElement(
								'p',
								null,
								'Il est important de savoir que des ',
								_react2.default.createElement(
									'strong',
									null,
									'd\xE9fauts de s\xE9curit\xE9'
								),
								' peuvent : '
							),
							_react2.default.createElement(
								'ul',
								{ className: 'snow' },
								_react2.default.createElement(
									'li',
									null,
									_react2.default.createElement(
										'strong',
										null,
										'nuire \xE0 l\'image de votre entreprise'
									),
									' (d\xE9figuration de sites web, d\xE9ni de service...)'
								),
								_react2.default.createElement(
									'li',
									null,
									_react2.default.createElement(
										'strong',
										null,
										'entra\xEEner des amendes cons\xE9quentes'
									),
									' si vous traitez des donn\xE9es ',
									_react2.default.createElement(
										'strong',
										null,
										'd\'utilisateurs \xE0 caract\xE8re personnel (',
										_react2.default.createElement(
											'a',
											{ href: 'https://www.cnil.fr/fr/principes-cles/rgpd-se-preparer-en-6-etapes', target: '_blank', title: 'en savoir plus \xE0 propos du RGPD' },
											'RGPD'
										),
										')'
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'article',
						{ className: 'full-medium' },
						_react2.default.createElement(
							'div',
							{ className: 'inner' },
							_react2.default.createElement(
								'header',
								{ className: 'major' },
								_react2.default.createElement(
									'h2',
									null,
									'Securite personnalisee'
								)
							),
							_react2.default.createElement(
								'p',
								{ className: 'preul' },
								'Le ',
								_react2.default.createElement(
									'strong',
									null,
									'suivi de s\xE9curit\xE9'
								),
								' concerne ces domaines :'
							),
							_react2.default.createElement(
								'ul',
								{ className: 'snow' },
								_react2.default.createElement(
									'li',
									null,
									_react2.default.createElement(
										'strong',
										null,
										'sites Internet'
									),
									' (CMS et Extensions, Framework ou d\xE9veloppements sp\xE9cifiques)'
								),
								_react2.default.createElement(
									'li',
									null,
									_react2.default.createElement(
										'strong',
										null,
										'services et applications'
									),
									' diverses'
								),
								_react2.default.createElement(
									'li',
									null,
									_react2.default.createElement(
										'strong',
										null,
										'equipements r\xE9seaux'
									),
									' Cisco, HP ...'
								),
								_react2.default.createElement(
									'li',
									null,
									_react2.default.createElement(
										'strong',
										null,
										'serveurs et postes de travail'
									),
									' Linux, Unix, Windows et Apple'
								)
							),
							_react2.default.createElement(
								'p',
								{ className: 'bordertop' },
								'Vous trouverez le d\xE9tail de mes comp\xE9tences dans ',
								_react2.default.createElement(
									'strong',
									null,
									_react2.default.createElement(
										_gatsbyLink2.default,
										{ to: '/cv/' },
										'mon CV'
									)
								),
								'.'
							)
						)
					),
					_react2.default.createElement(
						'article',
						{ className: 'full-medium' },
						_react2.default.createElement(
							'div',
							{ className: 'inner' },
							_react2.default.createElement(
								'header',
								{ className: 'major' },
								_react2.default.createElement(
									'h2',
									null,
									'Un suivi adapte'
								)
							),
							_react2.default.createElement(
								'p',
								null,
								'Assurer un ',
								_react2.default.createElement(
									'strong',
									null,
									'suivi des mises \xE0 jour de s\xE9curit\xE9 chaque mois'
								),
								' permet d\'effectuer une bonne veille avec un minimum de temps pass\xE9. Au final, c\'est le ',
								_react2.default.createElement(
									'strong',
									null,
									'meilleur rapport s\xE9curit\xE9 / co\xFBt prestation'
								),
								'.'
							),
							_react2.default.createElement(
								'p',
								null,
								'En choississant ce suivi, vous pourrez ',
								_react2.default.createElement(
									'strong',
									null,
									'contrer une grande partie des attaques'
								),
								' tout en b\xE9n\xE9ficiant ',
								_react2.default.createElement(
									'strong',
									null,
									'd\'une prestation \xE9conomique'
								),
								'.'
							),
							_react2.default.createElement(
								'p',
								{ className: 'bordertop' },
								'N\u2019h\xE9sitez pas \xE0 ',
								_react2.default.createElement(
									'strong',
									null,
									_react2.default.createElement(
										_gatsbyLink2.default,
										{ to: '#contact' },
										'me contacter'
									)
								),
								' pour un devis gratuit.'
							)
						)
					),
					_react2.default.createElement(
						'article',
						{ className: 'full-medium' },
						_react2.default.createElement(
							'div',
							{ className: 'inner' },
							_react2.default.createElement(
								'header',
								{ className: 'major' },
								_react2.default.createElement(
									'h2',
									null,
									'Mes garanties'
								)
							),
							_react2.default.createElement(
								'p',
								{ className: 'preul' },
								'Fort de mon exp\xE9rience dans le domaine depuis plus de ',
								_react2.default.createElement(
									'strong',
									null,
									'10 ans'
								),
								' (',
								_react2.default.createElement(
									_gatsbyLink2.default,
									{ to: '/CV/' },
									'CV'
								),
								'), je peux ',
								_react2.default.createElement(
									'strong',
									null,
									'vous accompagner et garantir'
								),
								' :'
							),
							_react2.default.createElement(
								'ul',
								{ className: 'snow' },
								_react2.default.createElement(
									'li',
									null,
									_react2.default.createElement(
										'strong',
										null,
										'une veille constante'
									),
									' sur les nouvelles ',
									_react2.default.createElement(
										'strong',
										null,
										'vuln\xE9rabilit\xE9s et attaques'
									),
									' d\xE9couvertes'
								),
								_react2.default.createElement(
									'li',
									null,
									'la ',
									_react2.default.createElement(
										'strong',
										null,
										'configuration'
									),
									' et le ',
									_react2.default.createElement(
										'strong',
										null,
										'suivi mensuel'
									),
									' des ',
									_react2.default.createElement(
										'strong',
										null,
										'r\xE9seaux, PC, serveurs, applications et sites Internet'
									),
									' pour assurer ',
									_react2.default.createElement(
										'strong',
										null,
										'un niveau de s\xE9curit\xE9 maximal'
									)
								),
								_react2.default.createElement(
									'li',
									null,
									'une ',
									_react2.default.createElement(
										'strong',
										null,
										'sensibilisation globale sur les bonnes pratiques'
									),
									' \xE0 adopter dans le secteur de l\'informatique'
								)
							),
							_react2.default.createElement(
								'p',
								{ className: 'bordertop' },
								'N\u2019h\xE9sitez pas \xE0 ',
								_react2.default.createElement(
									'strong',
									null,
									_react2.default.createElement(
										_gatsbyLink2.default,
										{ to: '#contact' },
										'me contacter'
									)
								),
								' pour un devis gratuit.'
							)
						)
					)
				)
			)
		);
	};
	
	exports.default = Generic;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-configuration-et-suivi-securite-informatique-js-5075676f3b2200d6c089.js